module.exports = __webpack_public_path__ + "media/images/component/service-cbe43dd16aeeae3c626daad1e0a10cb9.svg";